type Props = {
  open: boolean;
  saving: boolean;

  value: string;

  onTextChange: (value: string) => void;

  onClose: () => void;

  onImport: () => void;

  onDownloadTemplate: () => void;

  onUploadCsv: () => void;
};

const BulkImportModal = ({
  open,
  saving,

  value,
  onTextChange,

  onClose,
  onImport,

  onDownloadTemplate,
  onUploadCsv,
}: Props) => {

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

      <div className="w-[560px] rounded-xl bg-white shadow-xl">

        {/* Header */}

        <div className="flex items-start justify-between border-b px-6 py-5">

          <div>
            <h2 className="text-2xl font-semibold">
              Bulk import
            </h2>

            <p className="mt-1 text-sm text-gray-500">
              Paste rows as Emp ID, Name, NT IDs — or upload a CSV file.
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-2xl text-gray-400 hover:text-black"
          >
            ×
          </button>

        </div>

        {/* Body */}

        <div className="px-6 py-5">

          <div className="mb-3 flex items-center justify-between">

            <label className="text-sm font-semibold">
              Emp ID, Name, NT IDs
            </label>

            <div className="flex items-center gap-3">

              <button
                type="button"
                onClick={onDownloadTemplate}
                className="font-medium text-violet-700 hover:underline"
              >
                Download template
              </button>

              <span className="text-gray-300">|</span>

              <button
                type="button"
                onClick={onUploadCsv}
                className="font-medium text-violet-700 hover:underline"
              >
                Upload CSV
              </button>

            </div>

          </div>

          <textarea
            rows={8}
            value={value}
            onChange={(e) => onTextChange(e.target.value)}
            placeholder={`EmployeeCode,EmployeeName,NetworkId
              SG123456,John Doe,NT12345`}
            className="w-full rounded-lg border border-gray-300 p-3 text-sm outline-none focus:border-violet-600"
          />

          <p className="mt-4 text-sm text-gray-500">
            Existing employee IDs are updated in place; new ones are added as
            active employees on the general shift.
          </p>

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3 border-t px-6 py-4">

          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-6 py-2"
          >
            Cancel
          </button>

          <button
            type="button"
            disabled={saving}
            onClick={onImport}
            className="rounded-lg bg-violet-700 px-6 py-2 text-white hover:bg-violet-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {saving ? 'Importing...' : 'Import rows'}
          </button>

        </div>

      </div>

    </div>
  );
};

export default BulkImportModal;